import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Is this a physical book?',
  answer: 'No. This is a 100% Digital Collector Bundle. The moment you complete your order, you get instant access — no waiting, no shipping. Everything is delivered straight to your inbox.'
}, {
  question: 'How do I listen to the audiobook?',
  answer: 'You will receive high-quality MP3 files that play on any smartphone, tablet, or computer. iPhone, Android, Mac, PC — all compatible. No special app required.'
}, {
  question: 'Is my payment secure?',
  answer: 'Absolutely. We use industry-standard 256-bit SSL encryption — the same security used by major banks — to ensure your data is 100% protected at every step.'
}, {
  question: 'Can I share this with my family?',
  answer: 'Yes! In fact, we strongly encourage you to listen to these tracks with your children or grandchildren. This is a legacy you pass on — not a secret you keep.'
}, {
  question: 'Is this an official Charlie Kirk publication?',
  answer: 'This is an independent tribute publication created to preserve and celebrate the ideas and legacy that Charlie Kirk has championed throughout his career. Every word inside reflects the values he has publicly stood for — Faith, Freedom, and American Exceptionalism.'
}, {
  question: 'What if my spouse thinks this is a waste of money?',
  answer: "Show them this: for $17 — less than a lunch out — you get 3 complete digital books and audiobooks you can share with your entire family. That's $95.94 in total value. Most families listen together on road trips or during dinner. It has become a family tradition for thousands of patriots across the country."
}, {
  question: "I'm not very tech-savvy. Will I be able to access this?",
  answer: "If you can open an email and tap a link, you're completely set. You'll receive everything in your inbox within 60 seconds of your purchase. MP3 files for the audiobooks. PDF files for the eBooks. Everything works on your phone, tablet, or computer — no special app or account required. And our support team is standing by if you ever need help."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-16 px-4" data-id="element-154">
      <div className="max-w-3xl mx-auto" data-id="element-155">
        <h2 className="text-3xl font-bold text-center text-navy mb-4" data-id="element-156">
          Frequently Asked Questions
        </h2>
        <p className="text-center text-gray-500 mb-10" data-id="element-157">
          Everything you need to know before securing your bundle.
        </p>

        <div className="space-y-4" data-id="element-158">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-159">
              <button className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 flex justify-between items-center transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-160">
                <span className="font-bold text-navy pr-4" data-id="element-161">{faq.question}</span>
                <ChevronDown className={`text-gray-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-162" />
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 py-4 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-163">
                <p className="text-gray-600 leading-relaxed" data-id="element-164">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}